import { throttle } from 'lodash';

export function scrollAction() {
  window.addEventListener(
    'scroll',
    _.throttle(
      e => {
        
        return false;
      },
      50,
      { trailing: true, leading: true }
    )
  );
}